export { default } from "./TopicPage.js";
